import { render, staticRenderFns } from "./QualifiedEmployeesDialog.vue?vue&type=template&id=513bcf09&scoped=true"
import script from "./QualifiedEmployeesDialog.vue?vue&type=script&lang=ts"
export * from "./QualifiedEmployeesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513bcf09",
  null
  
)

export default component.exports